import { LOGIN, LOGOUT } from '../actions'
import dotProp from 'dot-prop-immutable';

const initialState = {
    id: '',
    name: '',
    picture: '',
    jwt_token: '',
    facebook_id: '',
    user_id: '',
    subscription: '',
    subscription_begin: '',
    subscription_expire: '',
}

export default (state, action) => {
    let state_ = state || initialState;
    switch (action.type) {
        case LOGIN:
            state_ = dotProp.set(state_, `id`, action.data.id);
            state_ = dotProp.set(state_, `name`, action.data.name);
            state_ = dotProp.set(state_, `picture`, action.data.picture);
            state_ = dotProp.set(state_, `jwt_token`, action.data.jwt_token);
            state_ = dotProp.set(state_, `facebook_id`, action.data.facebook_id);
            state_ = dotProp.set(state_, `user_id`, action.data.user_id);
            state_ = dotProp.set(state_, `subscription`, action.data.subscription);
            state_ = dotProp.set(state_, `subscription_begin`, action.data.subscription_begin);
            state_ = dotProp.set(state_, `subscription_expire`, action.data.subscription_expire);
            return state_
        case LOGOUT:
            state_ = dotProp.set(state_, `id`, '');
            state_ = dotProp.set(state_, `name`, '');
            state_ = dotProp.set(state_, `picture`, '');
            state_ = dotProp.set(state_, `jwt_token`, '');
            state_ = dotProp.set(state_, `facebook_id`, '');
            state_ = dotProp.set(state_, `user_id`, '');
            state_ = dotProp.set(state_, `subscription`, '');
            state_ = dotProp.set(state_, `subscription_begin`, '');
            state_ = dotProp.set(state_, `subscription_expire`, '');
            return state_
    }
    return state || initialState
}
